




















import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import InputFieldComponent  from "./InputFieldComponent.vue";
import DropDownComponent from "./DropDownComponent.vue";
import MultiSelectComponent from "./MultiSelectComponent.vue";
import FileUpload from "@/components/common/Inputs/FileUpload.vue";
import FileDownload from "@/components/common/fileDownload/fileDownload.vue";


@Component({
    components: {
        InputFieldComponent,
        DropDownComponent,
        MultiSelectComponent,
        FileUpload
    }
})
export default class ComponetLoader extends Vue {
  @Prop() items;
  @Prop() disabled;
  @Prop() data;
  @Prop() context;
  change(e)
  {
      this.$emit("update",e)
  }
}
